import {Api} from 'auth-advenio'

// This config file must be created locally. It is NOT versioned.
import {API_DOMAIN} from '../config'

import {getCookie} from '../utils/Utils'
import documentsApi from './Documents/documentsApi'

/**
 * Create a new API instance
 */
const api = Api.createInstance((API_DOMAIN || 'http://api.soyadvenio.com'), 200000)
const apiQa = Api.createInstance((`https://api-qa.miadvenio.com`), 200000)
const apiQaWoTimeout = Api.createInstance((`https://api-qa.miadvenio.com`), 100000000)
const apiWithoutTimeout = Api.createInstance((API_DOMAIN || 'http://api.soyadvenio.com'), 100000000)


Api.setAuthHeaders(getCookie('advenio_api_key')) // Attempt to set the auth token on app init

/**
 * Define functions that call the api. The goal is to provide a wrapper
 * of the api layer, by providing nicer functions rather than get, post, etc.
 */

// Auth
const login = data => api.post('auth/login', data)
const refreshToken = data => api.post('auth/refresh', data)
const checkAuthorized = () => api.post('auth/access', {platform: 'miadvenio'})
const impersonateUserDirector = data => api.post('auth/impersonate-director', data)
const stopImpersonateUser = () => api.post('auth/stop-impersonating')

const getCities = () => api.get('cities')

const getCountries = () => api.get('/countries')

// Health Teacher
const getHealthTeacherQuestions = userId => api.get(`miadvenio/health-teacher/${userId}`)
const postHealthTeacher = (userId, data) => api.post(`miadvenio/health-teacher/${userId}`, data)
const getQuestionHealthTeacher = () => api.get(`miadvenio/health-teacher/teacher-questions`)

// Health Check
const getHealthCheckQuestions = () => api.get('miadvenio/health-check/questions')
const postChildHealthCheck = (id, data) => api.post(`miadvenio/students/${id}/health-check`, data)
const postChildVirtualHealthCheck = (id, data) => api.post(`miadvenio/students/${id}/health-check`, data)

// Activity
const getActivityCategories = () => api.get('miadvenio/options/activity-categories')
const getPhotoCatalogue = (id, data) => api.get(`miadvenio/options/photo_desrcriptions`)
const postActivity = (id, data) => api.post(`miadvenio/checkins/${id}/activity`, data)
const editCheckout = (checkout_id, checkout_time) => api.patch(`miadvenio/checkout/${checkout_id}?checkout_time=${checkout_time}`)
const postFinishActivity = (id, data) => api.post(`miadvenio/activities/${id}/finish`, data)
const deleteActivity = activityId => api.delete(`miadvenio/activities/${activityId}`)
const postGroupActivity = data => api.post('miadvenio/group-activities/', data)
const getActivityExcel = (start_date, end_date, student_id) => api.get(`miadvenio/reports/activity/${student_id}?start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})


// Inventory
const getInventoryItems = () => api.get('miadvenio/inventory-items')
const getCheckinInventory = studentId => api.get(`miadvenio/students/${studentId}/checkin-inventory`)

// Cards
const getCards = ({student_id}) => api.get(`miadvenio/students/${student_id}/cards`)
const createCards = (student_id, parent_id, card_info) => api.post(`miadvenio/students/${student_id}/parents/${parent_id}/cards`, card_info)
const unauthorize = (student_id, card_id) => api.patch(`miadvenio/students/${student_id}/cards/${card_id}/unauthorize`)
const authorize = (student_id, card_id) => api.patch(`miadvenio/students/${student_id}/authorize-cards`, {card_id})
const activate = (student_id, card_id) => api.patch(`miadvenio/students/${student_id}/cards/${card_id}/default`, {})
const deleteCard = card_id => api.delete(`miadvenio/credit-cards/${card_id}`)
// Checkin
const postStudentCheckIn = (checkin_id, data) => api.post(`miadvenio/checkins/${checkin_id}/checkin-inventory`, data)
const searchStudent = name => api.get(`/miadvenio/search-students?name=${name}`)

// Checkout
const postStudentCheckOut = (checkin_id, data) => api.post(`miadvenio/checkins/${checkin_id}/checkout-inventory`, data)


// Centers
const getCenters = () => api.get('miadvenio/centers')
const getAllCenters = () => api.get('options/centers')
const getOneCenter = centerId => api.get(`centers/${centerId}`)
const getCenterOfClassroom = classroomId => api.get(`miadvenio/classroom/${classroomId}`)
const getCenterClassroom = centerId => api.get(`miadvenio/centers/${centerId}/options/classrooms`)
const getCenterCompanies = centerId => api.get(`miadvenio/centers/${centerId}/options/companies`)
const getCenterProducts = centerId => api.get(`miadvenio/centers/${centerId}/products`)
const centerParentPayment = centerId => api.get(`miadvenio/centers/${centerId}/center-payments`)
const getReservationBmx = (centerId, query) => api.get(`miadvenio/centers/${centerId}/reservations-bmx`, {params: {...query}})
const authorizeReservation = reservationId => api.post(`miadvenio/centers/reservations-bmx/${reservationId}/authorize/`)
const cancelReservation = reservationId => api.post(`miadvenio/centers/reservations-bmx/${reservationId}/cancel/`)
const pendingReservation = reservationId => api.post(`miadvenio/centers/reservations-bmx/${reservationId}/pending/`)
const paiedReservation = (reservationId, paymentId) => api.post(`miadvenio/centers/reservations-bmx/${reservationId}/paid/${paymentId}`)
const getSutdentPayments = studentId => api.get(`miadvenio/students/${studentId}/payments-card`)
const getReservationB2b = (centerId, query) => api.get(`miadvenio/centers/${centerId}/reservations-b2b`, {params: {...query}})
const postReservationB2b = (centerId, data) => api.post(`miadvenio/centers/${centerId}/reservations-b2b`, data)
const postServiceOccasional = (centerId, data) => api.post(`miadvenio/centers/${centerId}/occasional`, data)
const getServiceOccasional = ({centerId, query}) => api.get(`miadvenio/centers/${centerId}/occasional`, {params: {...query}})
const deleteServiceOccasional = (centerId, occasionalId) => api.delete(`miadvenio/centers/${centerId}/occasional/${occasionalId}`)
const exportServiceOccasional = ({centerId}) => api.get(`miadvenio/centers/${centerId}/occasional?export=true`, {responseType: 'blob'})

// Companies

const getCompanies = () => apiWithoutTimeout.get('options/companies')

// enrollments
const getInscriptions = query => api.get('miadvenio/enrollments', {params: {...query}})
const getDisenrollments = query => api.get('miadvenio/disenrollments', {params: {...query}})
const getReservedEnrollments = query => api.get('miadvenio/reserved-enrollments', {params: {...query}})
const getReEnrollments = query => api.get('miadvenio/reenrollments', {params: {...query}})

// Students
const getClassrooms = query => api.get(`miadvenio/classrooms`, {params: {...query}})
const getActivities = (id, query) => api.get(`miadvenio/students/${id}/activities`, {params: {...query}})
const getCompleteInfoStudent = (id, timestamp) => api.get(`miadvenio/students/${id}?deleted=true&last_updated=${timestamp}`)
const getCompleteInfoParent = (id, studentId) => api.get(`miadvenio/students/${studentId}/parents/${id}`)
const updateStudent = (id, profile) => api.patch(`miadvenio/students/${id}`, profile)
const updateParent = (id, studentId, profile) => api.patch(`miadvenio/students/${studentId}/parents/${id}`, profile)
const sendMailInstitutional = (id, studentId) => api.post(`miadvenio/students/${studentId}/parents/${id}/send-mail`)
const deleteStudent = (id, deleteInfo) => api.delete(`miadvenio/students/${id}`, {params: deleteInfo})
const restoreStudent = id => api.put(`miadvenio/students/${id}/restore`)
const getInvoices = (id, queries) => api.get(`miadvenio/students/${id}/invoices`, {params: {...queries}})
const createParent = (studentId, info) => api.post(`miadvenio/students/${studentId}/parents`, info)

// Contracts
const getContracts = parentId => api.get(`miadvenio/parents/${parentId}/available-contracts`)
const getCenterByContract = contractId => api.get(`miadvenio/contract/${contractId}/centers`)
const getContractsByCompanyId = companyId => api.get(`/companies/${companyId}/contracts?include=products`)
// Reminder
const sendReminder = studentId => api.post(`miadvenio/students/${studentId}/send-payment-reminders`)
const sendAllReminder = centerId => api.post(`miadvenio/centers/${centerId}/send-all-payment-reminders`)
const getReminders = (centerId, queries) => api.get(`miadvenio/centers/${centerId}/student-accounts?filter=unpaid`, {params: {...queries}})

// StudyPrograms
const getStudyPrograms = centerId => api.get(`miadvenio/centers/${centerId}/study-programs`)

// HistoricalRecords
const getHistorical = ({studentId}) => api.get(`miadvenio/students/${studentId}/historical-records`)

// Disenrollment categories
const getDisenrollmentCategories = () => api.get('/miadvenio/disenrollment-categories')

// Medicines Center
const getMedicinesCenter = (centerId, query) => api.get(`/miadvenio/centers/${centerId}/medications`, {params: {...query}})
const applyMedicine = (medicine_id, apply_info) => api.post(`/miadvenio/medications/${medicine_id}/apply`, apply_info)
const deleteMedicine = (medicine_id) => api.delete(`/miadvenio/medications/${medicine_id}`)
// <-----------------PARENT PLATFORM--------------------->

const getChildren = () => api.get('miadvenio/children')
const getProfile = childId => api.get(`miadvenio/children/${childId}`)
const updateChildren = (id, profile) => api.patch(`miadvenio/children/${id}`, profile)

const childCheckin = (childId, data) => api.post(`http://demo9864377.mockable.io/parent/${childId}/children`, data)
const createMedicine = medicineInfo => api.post('miadvenio/medications', medicineInfo)
const getMedicine = ({student_id}) => api.get(`miadvenio/students/${student_id}/medications`)
const postHomeReport = (studentId, data) => api.post(`miadvenio/children/${studentId}/home-report`, data)
const getHomeReportStudent = studentId => api.get(`miadvenio/students/${studentId}/home-report`)
const getReservations = studentId => api.get(`miadvenio/children/${studentId}/reservations`)
const postReservation = (studentId, data) => api.post(`miadvenio/children/${studentId}/reservations`, data)
const updateResevation = (id, data) => api.patch(`miadvenio/children/reservations/${id}`, data)
const deleteReservation = id => api.delete(`miadvenio/children/reservations/${id}`,)

const getRating = studentId => api.get(`miadvenio/ratings/${studentId}?today=true`)
const submitRating = rating => api.post('miadvenio/ratings', rating)
const getParentBalance = ({studentId, page}) => api.get(`miadvenio/children/${studentId}/transactions?page=${page}`)
const getPhotos = ({studentId, page}) => api.get(`miadvenio/students/${studentId}/photos?page=${page}`)

// Enroll
const postEnroll = (studentId, data) => api.patch(`miadvenio/students/${studentId}/enroll`, data)
const postReserved = (studentId, data) => api.patch(`miadvenio/students/${studentId}/enroll`, data)
const postReEnroll = (studentId, data) => api.patch(`miadvenio/students/${studentId}/reenroll`, data)
const postReEnrollFromDisenrollments = (studentId, data) => api.patch(`miadvenio/students/${studentId}/reenroll`, data)
const deleteEnroll = (studentId, data) => api.delete(`miadvenio/students/${studentId}/enrollment`, {params: data})

// Payment types
const getPaymentTypes = () => api.get('miadvenio/payment-types')
const getPaymentTypesMsi = () => api.get('miadvenio/payment-types-msi')

// Consumbales
const getConsumbales = (centerId, query = {}) => api.get(`miadvenio/centers/${centerId}/consumables`, {params: {...query}})
const getConsumbalesCategories = () => api.get('consumable_categories')

// Balance
const getBalance = ({studentId}) => api.get(`miadvenio/students/${studentId}/account`)
const getMoreBalance = ({studentId, page}) => api.get(`miadvenio/students/${studentId}/account?page=${page}`)
const createCharge = (studentId, charges) => api.post(`miadvenio/students/${studentId}/charges`, charges)
const deleteCharge = chargeId => api.delete(`miadvenio/charges/${chargeId}`)
const changeCharge = chargeId => api.patch(`miadvenio/charges/${chargeId}/isretention`)
const deletePayment = paymentId => api.delete(`admin/student-payments/${paymentId}`)
const createDiscount = (chargeId, data) => api.post(`miadvenio/charges/${chargeId}/discount`, data)
const adjustDiscount = (chargeId, data) => api.patch(`miadvenio/discounts/${chargeId}`, data)
const adjustTransaction = (ReceiptId, data) => api.patch(`admin/receipts/${ReceiptId}/transactions`, data)
const createPayment = (studentId, payment) => api.post(`miadvenio/students/${studentId}/payments`, payment)
const createReceipt = studentId => api.post(`miadvenio/students/${studentId}/receipts`)

// Notifications config
const getNotifications = () => api.get('miadvenio/options/notification-types')
const updateNotifications =
  (studentId, activeNotifications) => api.patch(`miadvenio/students/${studentId}/notifications`, activeNotifications)
const updateParentNotifications =
  (studentId, activeNotifications) => api.patch(`miadvenio/children/${studentId}/notifications`, activeNotifications)

const getRelations = () => api.get('options/relations')
const getCenterOptions = () => api.get('options/centers')
const getFinances = () => api.get('miadvenio/reports/finances')
const getRatings = () => api.get('miadvenio/reports/ratings')
const getCheckins = () => api.get('miadvenio/reports/attendance/checkin')
const getAttendance = () => api.get('miadvenio/reports/attendance')
const getDailyAttendance = () => apiWithoutTimeout.get('miadvenio/reports/attendance/daily')
const getTotalAttendance = () => api.get('miadvenio/reports/attendance/total-hours')
const getAverageAttendance = () => api.get('miadvenio/reports/attendance/average')
const getVisitAverageAttendance = () => api.get('miadvenio/reports/attendance/center-visit-average')
const getCenterVisitAverage = () => api.get('miadvenio/reports/attendance/center-visit-average')
const getStudentCheckin = () => api.get('miadvenio/reports/attendance/student-checkin')
const getDemographics = () => api.get('miadvenio/reports/demographics')
const getNet = () => api.get('miadvenio/reports/enrollments/net')
const getMotives = () => api.get('miadvenio/reports/enrollments/motives')
const getOverview = () => api.get('miadvenio/reports/overview')
const getTeacherDistribution = () => api.get('miadvenio/reports/attendance/teacher-distribution')
const getActiveCheckins = () => api.get('miadvenio/reports/attendance/active-checkins-distribution')
const getAssistanceExcel = (start_date, end_date, path) => api.get(`miadvenio/reports/attendance/${path}?export=true&start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})
const getIncidentExcel = (start_date, end_date) => api.get(`miadvenio/reports/incidents?start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})
const getMedalliaExcel = (start_date, end_date, type_quiz) => api.get(`miadvenio/reports/medallia?start_date=${start_date}&end_date=${end_date}&type_quiz=${type_quiz}`, {responseType: 'blob'})
const getCentersExcel = (path, centerId) => api.get(`miadvenio/reports/centers/${centerId}/${path}?export=true`, {responseType: 'blob'})
const getAssistanceCenterExcel = (start_date, end_date, centerId, path) => api.get(`miadvenio/reports/centers/${centerId}/attendance/${path}?export=true&start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})
const getCentersIncidentExcel = (start_date, end_date, centerId) => api.get(`miadvenio/reports/centers/${centerId}/incidents?start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})
const getCheckinsExcel = () => api.get('miadvenio/reports/attendance/checkin?export=true', {responseType: 'blob'})
const getEnrollmentReportExcel = (start_date, end_date) => api.get(`miadvenio/reports/enrollmentreport?start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})
const getCentersEnrollmentReportExcel = (start_date, end_date, centerId) => api.get(`miadvenio/reports/centers/${centerId}/enrollmentreport?start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})
const getDisenrollmentReportExcel = (start_date, end_date,) => api.get(`miadvenio/reports/disenrollmentreport?start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})
const getCentersDisenrollmentReportExcel = (start_date, end_date, centerId) => api.get(`miadvenio/reports/centers/${centerId}/disenrollmentreport?start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})
const getMasterListReportExcel = (start_date, end_date,) => api.get(`miadvenio/reports/masterlistreport?start_date=${start_date}&end_date=${end_date}&export=true`, {responseType: 'blob'})
const getCentersMasterListReportExcel = (start_date, end_date, centerId) => api.get(`miadvenio/reports/centers/${centerId}/masterlistreport?start_date=${start_date}&end_date=${end_date}&export=true`, {responseType: 'blob'})
const getReceiptReportExcel = (start_date,end_date) => api.get(`miadvenio/reports/receiptreport?start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})
const getCentersReceiptReportExcel = (start_date,end_date,centerId) => api.get(`miadvenio/reports/centers/${centerId}/receiptreport?start_date=${start_date}&end_date=${end_date}`, {responseType: 'blob'})
const getRatingsExcel = () => api.get('miadvenio/reports/ratings?export=true', {responseType: 'blob'})
const getStudentCheckinExcel = () => api.get('miadvenio/reports/attendance/student-checkin?export=true', {responseType: 'blob'})
const getAttendanceByHourExcel = () => api.get('miadvenio/reports/attendance/total-hours?export=true', {responseType: 'blob'})
const getAttendanceExcel = () => api.get('miadvenio/reports/attendance/daily?export=true', {responseType: 'blob'})
const getFinancesExcel = () => api.get('miadvenio/reports/finances?export=true', {responseType: 'blob'})
const getNetExcel = () => api.get('miadvenio/reports/enrollments/net?export=true', {responseType: 'blob'})
const getMotivesExcel = () => api.get('miadvenio/reports/enrollments/motives?export=true', {responseType: 'blob'})
const getDemographicsExcel = () => api.get('miadvenio/reports/demographics?export=true', {responseType: 'blob'})
const getDailyAttendanceExcel = () => api.get('miadvenio/reports/attendance/daily?export=true', {responseType: 'blob'})
const getTotalAttendanceExcel = () => api.get('miadvenio/reports/attendance/total-hours?export=true', {responseType: 'blob'})
const getAverageAttendanceExcel = () => api.get('miadvenio/reports/attendance/average?export=true', {responseType: 'blob'})
const getVisitAverageAttendanceExcel = () => api.get('miadvenio/reports/attendance/center-visit-average?export=true', {responseType: 'blob'})
const getTeacherDistributionExcel = () => api.get('miadvenio/reports/attendance/teacher-distribution?export=true', {responseType: 'blob'})
const getActiveCheckinsExcel = () => api.get('miadvenio/reports/attendance/active-checkins-distribution?export=true', {responseType: 'blob'})
const getParentPaymentTypes = () => api.get('/options/payment-types')
const getServiceTypes = () => api.get('/options/service-types')
const addSibling = (studentId, data) => api.post(`miadvenio/students/${studentId}/add-sibling`, data)
const sendingPerson = (data) => api.post(`miadvenio/courses/person`, data)
const getCenterCourses = (centerId) => api.get(`miadvenio/courses/${centerId}`)

// Photos
const getUnvalidatedPhotos = query => api.get('miadvenio/activity-photos/unvalidated', {params: {...query}})
const validatePhoto = photoId => api.patch(`miadvenio/activity-photos/${photoId}/validate`)
const deletePhoto = photoId => api.delete(`miadvenio/activity-photos/${photoId}`)

// Receipts
const getUnvalidatedReceipts = query => api.get('admin/receipts?status=unvalidated', {params: {...query}})
const getValidatedReceipts = query => api.get('admin/receipts?status=validated', {params: {...query}})
const validateReceipt = id => api.patch(`admin/receipts/${id}/validate`)
const unvalidateReceipt = (id, body) => api.patch(`admin/receipts/${id}/unvalidate`,body)
const exportUnvalidatedReceipts = () => api.get('/admin/receipts/unvalidated/export', {responseType: 'blob', timeout: 30000})

const getDomiciliations = (centerId) =>
  api.get(`miadvenio/centers/${centerId}/domiciliations`)

const getDomiciliationsExcel = (centerId) =>
  api.get(`miadvenio/centers/${centerId}/domiciliations?export=true`, { responseType: 'blob' })

const getAllDomiciliations = (page) =>
  api.get('miadvenio/domiciliations', { params: { page } })

const getAllDomiciliationsExcel = () =>
  api.get('miadvenio/domiciliations?export=true', { responseType: 'blob' })

const getStudentUnvalidatedReceipts = studentId => api.get(`miadvenio/students/${studentId}/receipts?status=unvalidated`)
const getStudentValidatedReceipts = (studentId, query) => api.get(`miadvenio/students/${studentId}/receipts?status=validated&without_retention=true`, {params: {...query}})
const addChargeToReceipt = (chargeId, receiptId) => api.post(`miadvenio/charges/${chargeId}/receipts/${receiptId}`)
const removeChargeFromReceipt = (chargeId, receiptId) => api.delete(`miadvenio/charges/${chargeId}/receipts/${receiptId}`)

const createParentPayment = (id, data) => api.post(`miadvenio/children/${id}/payments`, data)

const getIncidentTypes = () => api.get('miadvenio/options/incident-types')
const getEmergencyMedications = () => api.get('miadvenio/options/emergency-medications')
const getMood = () => api.get('miadvenio/options/moods')

const getProgramLevels = () => api.get('options/study-program-levels')
const getEnrollmentsCategories = () => api.get('miadvenio/enrollment-categories')
const getUnitKeys = () => api.get('options/sat/unit-keys')
const getRegimenfiscal = () => api.get('options/sat/regimen-fiscal')
const getUsocFDI = () => api.get('options/sat/uso-cfdi')
const getCentersInfo = (centerId, path) => api.get(`miadvenio/reports/centers/${centerId}/${path}`)


const resetPassword = data => api.post('auth/password/forgot', data)
const setNewPassword = (token, data) => api.post(`auth/password/${token}/reset`, data)
const validateToken = token => api.get(`auth/password/${token}`)

const getAdvancedSearch = query => api.get('miadvenio/advanced-search', {params: {...query}})
const postUserPicture = (id, data) => api.patch(`backend/users/${id}/profile-pic`, data)
const postUserTokenFCM = (id, data) => api.post(`backend/users/${id}/token-fcm`, data)

const getResultsCatalogue = () => api.get('miadvenio/evaluation/catalogues/results')
const getDimentionsCatalogue = () => api.get('miadvenio/evaluation/catalogues/dimentions')
const getCyclesCatalogue = () => api.get('miadvenio/evaluation/catalogues/cycles')
const getStudyProgramsCatalogue = () => api.get('miadvenio/evaluation/catalogues/study-programs')
const getDimentionByStudyProgram = (studentId, studyProgramId) => api.get(`miadvenio/students/${studentId}/evaluation/program/${studyProgramId}`)
const patchEvaluation = (payload) => api.patch(`miadvenio/students/${payload.studentId}/evaluation/${payload.evaluationId}`, {...payload.body})
const createEvaluation = (payload) => api.post(`miadvenio/students/${payload.studentId}/evaluation/program/${payload.studyProgramId}`)
const deleteEvaluation = (payload) => api.delete(`miadvenio/students/${payload.studentId}/evaluation/${payload.evaluationId}`)
const generatePDF = (payload) => api.post(`miadvenio/students/${payload.studentId}/evaluation/${payload.evaluationId}/generate-achievements-pdf`)

/**
 * Create a collection of the previous functions to be exposed
 */
export default {
  allCenters: {
    get: getAllCenters,
  },
  advanced_search: {
    get: getAdvancedSearch,
  },
  activity: {
    get: getActivityCategories,
    postActivity,
    getPhotoCatalogue,
    postFinishActivity,
    deleteActivity,
    postGroupActivity,
    getActivityExcel,
    editCheckout,
  },
  addSibling: {
    addSibling,
  },
  auth: {
    login,
    refreshToken,
    checkAuthorized,
    impersonateUserDirector,
    stopImpersonateUser,
    resetPassword,
    setNewPassword,
  },
  resetPassword: {
    get: validateToken,
  },
  unitKeys: {
    get: getUnitKeys,
  },
  attendance: {
    get: getAttendance,
    getAttendanceByHourExcel,
    getAttendanceExcel,
  },
  assistance: {
    getAssistanceCenterExcel,
    getAssistanceExcel
  },
  centersExcel: {
    getCentersExcel,
  },
  centersInfo: {
    getCentersInfo,
  },
  dailyAttendance: {
    get: getDailyAttendance,
    getDailyAttendanceExcel,
  },
  enrollmentsCategories: {
    get: getEnrollmentsCategories,
  },
  net: {
    get: getNet,
    getNetExcel,
  },
  motives: {
    get: getMotives,
    getMotivesExcel,
  },
  totalAttendance: {
    get: getTotalAttendance,
    getTotalAttendanceExcel,
  },
  averageAttendance: {
    get: getAverageAttendance,
    getAverageAttendanceExcel,
  },
  visitAverageAttendance: {
    get: getVisitAverageAttendance,
    getVisitAverageAttendanceExcel,
  },
  activeCheckins: {
    get: getActiveCheckins,
    getActiveCheckinsExcel,
  },
  balance: {
    get: getBalance,
    createCharge,
    deleteCharge,
    changeCharge,
    deletePayment,
    createDiscount,
    adjustDiscount,
    adjustTransaction,
    createPayment,
    getMoreBalance,
    createReceipt,

  },
  cards: {
    get: getCards,
    create: createCards,
    unauthorize,
    authorize,
    activate,
    delete: deleteCard,
  },
  centers: {
    get: getCenters,
    getOne: getOneCenter,
    getCenterByContract,
  },
  centerClassroom: {
    get: getCenterClassroom,
    getCenterOfClassroom,
  },
  centerVisitAverage: {
    get: getCenterVisitAverage,
  },
  center_products: {
    get: getCenterProducts,
  },
  centerOptions: {
    get: getCenterOptions,
  },
  demographics: {
    get: getDemographics,
    getDemographicsExcel,
  },
  domiciliationReport: {
    get: getDomiciliations,
    getAll: getAllDomiciliations,
    export: getDomiciliationsExcel,
    exportAll: getAllDomiciliationsExcel,
  },
  finances: {
    get: getFinances,
    getFinancesExcel,
  },
  checkins: {
    get: getCheckins,
    getCheckinsExcel,
  },
  incident: {
    getIncidentExcel,
    getCentersIncidentExcel,
  },
  medallia: {
    getMedalliaExcel,
  },
  enrollmentreport: {
    getEnrollmentReportExcel,
    getCentersEnrollmentReportExcel,
  },
  disenrollmentreport: {
    getDisenrollmentReportExcel,
    getCentersDisenrollmentReportExcel,
  },
  masterlistreport: {
    getMasterListReportExcel,
    getCentersMasterListReportExcel,
  },
  receiptreport: {
    getReceiptReportExcel,
    getCentersReceiptReportExcel,
  },
  ratings: {
    get: getRatings,
    getRatingsExcel,
  },
  teacherDistribution: {
    get: getTeacherDistribution,
    getTeacherDistributionExcel,
  },
  classrooms: {
    get: getClassrooms,
    getStudentProfile: getCompleteInfoStudent,
    getParentProfile: getCompleteInfoParent,
    updateStudent,
    updateParent,
    deleteStudent,
    restoreStudent,
    getInvoices,
    createParent,
    sendMailInstitutional,
  },
  cities: {
    get: getCities,
  },
  companies: {
    get: getCompanies,
    getCenterCompanies,
  },
  contracts: {
    getContracts,
    getContractsByCompanyId,
  },
  consumables: {
    get: getConsumbales,
  },
  consumables_categories: {
    get: getConsumbalesCategories,
  },
  countries: {
    get: getCountries,
  },
  checkin_inventory: {
    get: getCheckinInventory,
  },
  checkin: {
    postCheckIn: postStudentCheckIn,
    searchStudent,
  },
  home_report: {
    postHomeReport,
    getHomeReportStudent,
  },
  checkout: {
    postCheckOut: postStudentCheckOut,
  },
  disenrollment: {
    get: getDisenrollmentCategories,
  },
  disenrollments: {
    get: getDisenrollments,
  },
  emergencyMedications: {
    get: getEmergencyMedications,
  },
  enroll: {
    postEnroll,
    deleteEnroll,
  },
  studentProfile: {
    getActivities,
    getInfo: getCompleteInfoStudent,
    getOne: getCompleteInfoStudent,
  },
  healthCheck: {
    get: getHealthCheckQuestions,
    postHealthCheck: postChildHealthCheck,
    postVirtualHealthCheck: postChildVirtualHealthCheck,
  },
  historical: {
    get: getHistorical,
  },
  inventory: {
    get: getInventoryItems,
  },

  incidentTypes: {
    get: getIncidentTypes,
  },
  inscriptions: {
    get: getInscriptions,
  },
  medicines_center: {
    get: getMedicinesCenter,
    applyMedicine,
    deleteMedicine,
  },
  mood: {
    get: getMood,
  },
  notifications_types: {
    get: getNotifications,
    updateNotifications,
    updateParentNotifications,
  },
  overview: {
    get: getOverview,
  },
  parent_payment_types: {
    get: getParentPaymentTypes,
    centerParentPayment
  },
  parent_platform_children: {
    get: getChildren,
    checkin: childCheckin,
    getProfile,
    update: updateChildren
  },
  parent_platform_rating: {
    get: getRating,
    submit: submitRating,
  },
  parent_platform_medicine: {
    create: createMedicine,
    get: getMedicine,
  },
  parent_platform_reservation: {
    postReservation,
    updateResevation,
    deleteReservation,
    get: getReservations,
  },
  parent_platform_payments: {
    createParentPayment,
  },
  parent_platform_balance: {
    get: getParentBalance,
  },
  payment_reminders: {
    getAll: getReminders,
    sendAll: sendAllReminder,
    sendOne: sendReminder,
  },
  payment_types: {
    get: getPaymentTypes,
  },
  payment_types_msi: {
    get: getPaymentTypesMsi,
  },
  service_types: {
    get: getServiceTypes,
  },
  programLevels: {
    get: getProgramLevels,
  },
  reserved_enrollments: {
    get: getReservedEnrollments,
  },
  reEnroll: {
    postReEnroll,
  },
  reserved: {
    postReserved,
  },
  re_enrollments: {
    get: getReEnrollments,
  },
  reEnrollFromDisenrollments: {
    postReEnrollFromDisenrollments,
  },
  study_programs: {
    get: getStudyPrograms,
  },
  studentCheckin: {
    get: getStudentCheckin,
    getStudentCheckinExcel,
  },
  student_photos: {
    getPhotos,
  },
  relations: {
    get: getRelations,
  },
  unvalidatedPhotos: {
    get: getUnvalidatedPhotos,
    validate: validatePhoto,
    delete: deletePhoto,
  },
  unvalidatedReceipts: {
    get: getUnvalidatedReceipts,
    validate: validateReceipt,
    export: exportUnvalidatedReceipts,
  },
  validatedReceipts: {
    get: getValidatedReceipts,
    unvalidate: unvalidateReceipt,
  },
  chargesToReceipts: {
    get: getStudentUnvalidatedReceipts,
    getStudentValidatedReceipts,
    link: addChargeToReceipt,
    unlink: removeChargeFromReceipt,
  },
  reservationBmx: {
    getReservationBmx,
    authorizeReservation,
    cancelReservation,
    pendingReservation,
    paiedReservation,
    getSutdentPayments,
    getReservationB2b,
    postReservationB2b,
  },
  healthTeacher: {
    get: getHealthTeacherQuestions,
    postHealthTeacher,
    getQuestionHealthTeacher,
  },
  courses: {
    sendingPerson,
    get: getCenterCourses
  },
  regimen_fiscal: {
    get: getRegimenfiscal,
  },
  uso_cfdi: {
    get: getUsocFDI,
  },
  users: {
    postUserPicture,
    postUserTokenFCM
  },
  serviceOccasional: {
    post: postServiceOccasional,
    get: getServiceOccasional,
    export: exportServiceOccasional,
    delete: deleteServiceOccasional,
  },
  evaluation:{
    catDimentions: getDimentionsCatalogue,
    catResults: getResultsCatalogue,
    catCycles: getCyclesCatalogue,
    catStudyPrograms: getStudyProgramsCatalogue,
    getDimentionByStudyProgram,
    patch: patchEvaluation,
    create: createEvaluation,
    delete: deleteEvaluation,
    generatePDF: generatePDF,
  },
  // Documents API
  ...documentsApi,
}



// WEBPACK FOOTER //
// ./src/Data/Api.js